export class MessageKanriModel{

  public houjin: string;

  public messageId: string;

  public messageHonbun: string;

  public syubetsu: string;

  public btnSyubetsu: string;

  public bikou: string;

  public hyoujiKbun: string;

  public messageIdHyoujiHuragu: string;

  public messageDaigaeHuragu: string;

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/message-kanri-model.ts